import service from "./server";
import {AxiosPromise} from "axios";
import qs from "qs";
import { CONFIG } from "./config";
import {DetectIntentReq, DownloadByButtonReq, ReportUserAction} from "../types/chat-msg-types";
import { ReqSuggestionHit } from "../types/chat-suggestion-types";
import { OtpReq, AccessCodeReqBody } from "../types/chat-authentication-types";
import {FeedbackReq} from "../types/chat-feedback-types";


const conversationUrl = CONFIG.CONVERSATION_EXTERNAL+"v1";

const fulfillmentUrl=CONFIG.FULFILLMENT_DOMAIN+"v1";
export function getSessionId(): AxiosPromise {
    return service({
        url: conversationUrl + "/conversations/sessions",
        method: "post",
        data:{}
    });
}

export function getApplicationThemeApi():AxiosPromise{
    return  service({
        url:conversationUrl + "/conversations/getTheme",
        method: "post",
        data:{}
    });
}


export function detectIntent(data: DetectIntentReq): AxiosPromise {
    return service({
        url: conversationUrl + "/conversations/detectIntent",
        method: "post",
        data: data,
        paramsSerializer: (params) => {
            return qs.stringify(params, {indices: false});
        },
    });
}

//authentication
export function authenticationApi(data: OtpReq): AxiosPromise {
    return service({
        url: conversationUrl + "/conversations/authentication",
        method: "post",
        data: data
    });
}

//for external
export function retrieveChatHistoryBySessionIdApi(): AxiosPromise {
    return service({
        url:conversationUrl + "/conversations/retrieveChatHistoryBySessionId",
        method: "post",
    });
}

export function toQuerySuggestionApi(data: ReqSuggestionHit): AxiosPromise {
    return service({
        url:conversationUrl + "/conversations/getSuggestion",
        method: "post",
        data: data,
    });
}

export function retrieveLastSessionApi(data: Date): AxiosPromise {
    return service({
        url:conversationUrl + "/conversations/retrieveChatHistory",
        method: "post",
        data: { "queryDate": data }
    });
}

export function getWelcomeMsgApi(): AxiosPromise {
    return service({
        url: conversationUrl + "/conversations/getWelcomeMsg",
        method: "post",
    });
}


export function getAccessCodeLoginParamApi(): AxiosPromise {
    return service({
        url: conversationUrl + "/conversations/getAccessCodeParam",
        method: "post",
    });
}

export function accessCodeLoginApi(data: AccessCodeReqBody): AxiosPromise {
    return service({
        url: conversationUrl + "/conversations/accessCodeLogin",
        method: "post",
        data: data,
    });
}


export function submitFeedbackApi(data: FeedbackReq): AxiosPromise {
    return service({
        url: conversationUrl+"/conversations/qualtrics/sendingQualtrics",
        method: "post",
        data: data,
    });
}

export function repostUserActionApi(data: ReportUserAction): AxiosPromise {
    return service({
        url: conversationUrl + "/conversations/reportUserAction",
        method: "post",
        data: data,
    });
}

export function downloadByButtonApi(data: DownloadByButtonReq): AxiosPromise {
    return service({
        url: conversationUrl + "/conversations/application/downloadFileByButton",
        method: "post",
        responseType: "blob",
        data: data,
    });
}